import { TextInput } from "@mantine/core";
import React from "react";

const CustomInput = ({ onChange, value, name, type, placeholder }) => {
  return (
    <TextInput
      label={name}
      value={value}
      onChange={onChange}
      type={type ?? "text"}
      placeholder={placeholder}
      styles={{ label: { fontWeight: 600 } }}
    />
  );
};

export default CustomInput;
